module.exports = __webpack_public_path__ + "static/media/ACVAuctions.ca7408cd.png";